<template>
    <v-dialog :value="$store.getters['bookings/manageBookingDialog']" fullscreen>
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn @click="closeDialog" icon dark>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Manage Booking</v-toolbar-title>
                <v-spacer />
                <v-toolbar-items>
                    <v-btn :loading="isLoading" :disabled="isLoading" @click="processBooking" dark text>Save</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col v-if="editInOldSystem" cols="12">
                            <v-alert class="white--text" color="error">EDIT IN OLD SYSTEM</v-alert>
                        </v-col>
                        <v-col cols="12">
                            <rs-canvas :fromEstimateForm="true" :isEditable="isEdit" :isNew="isEdit" :booking="booking" />
                            <v-divider class="mt-3" />
                            <v-tabs vertical v-model="tab">
                                <v-tab>
                                    <v-icon left>mdi-account</v-icon>
                                    Customer
                                </v-tab>
                                <v-tab>
                                    <v-icon left>mdi-image-broken-variant</v-icon>
                                    Damage
                                </v-tab>
                                <v-tab class="text-left">
                                    <v-icon left>mdi-account-tie</v-icon>
                                    Contractors
                                </v-tab>
                                <v-tab class="text-left">
                                    <v-icon left>mdi-car</v-icon>
                                    Courtesy Car
                                </v-tab>
                                <v-tab>
                                    <v-icon left>mdi-tools</v-icon>
                                    Parts
                                </v-tab>
                                <v-tab>
                                    <v-icon left>mdi-account-card-details</v-icon>
                                    Details
                                </v-tab>
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <rs-customer :booking="booking" />
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <rs-damage :booking="booking" />
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <rs-contractors :booking="booking" />
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <rs-courtesy-car :booking="booking" />
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <rs-parts :booking="booking" />
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <rs-details :booking="booking" />
                                            <v-btn class="mt-2" :loading="isLoading" :disabled="isLoading" @click="processBooking" color="primary">Save Booking</v-btn>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                            </v-tabs>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import RsCanvas from "./sections/RsCanvas";
    import RsCustomer from "./sections/RsCustomer";
    import RsDamage from "./sections/RsDamage";
    import RsContractors from "./sections/RsContractors";
    import {EventBus} from "../../../EventBus";
    import RsCourtesyCar from "./sections/RsCourtesyCar";
    import RsParts from "./sections/RsParts";
    import RsDetails from "./sections/RsDetails";
    import {BookingsHttp} from "../../../http/bookings";
    import {EstimatesHttp} from "../../../http/estimates";
    import {toAmount} from "../../../helper/amount";
    export default {
        name: "BookingDialog",
        components: {RsParts, RsCourtesyCar, RsDamage, RsCustomer, RsCanvas, RsContractors, RsDetails},
        mounted() {
            EventBus.$on('damage-selected', () => {
                this.tab = 2;
                this.updateTotals();
            });

            EventBus.$on('part-added', part => {
                if (!this.booking.parts) {
                    this.booking.parts = [];
                }
                this.booking.parts.push(part);
                this.updateTotals();
            });

            EventBus.$on('part-removed', name => {
                this.booking.parts.splice(this.booking.parts.findIndex(x => x.name === name), 1);
                this.updateTotals();
            });

            EventBus.$on('customer-selected', () => {
                this.tab = 1;
            });
        },
        data() {
            return {
                isEdit: false,
                tab: null,
                isLoading: false,
                editInOldSystem: false
            }
        },
        computed: {
            booking: {
                get() {
                    return this.$store.state.bookings.activeBooking;
                }
            }
        },
        watch: {
            booking: {
                handler(newVal) {
                    if (newVal._id) {
                        this.isEdit = true;
                        newVal.startDate = new Date(newVal.startDate).toISOString().substr(0, 10);
                    }
                    if (newVal.damage && newVal._id) {
                        newVal.damage.forEach(d => {
                            this.editInOldSystem = !d.repairDetail;
                        });
                    }
                },
                deep: true,
                immediate: true
            }
        },
        methods: {
            updateTotals() {
                this.booking.total = 0;
                if (this.booking.damage) {
                    this.booking.damage.forEach(damage => {
                        this.booking.total = this.booking.total + toAmount(damage.labour);
                    });
                }
                if (this.booking.parts) {
                    this.booking.parts.forEach(part => {
                        this.booking.total = this.booking.total + toAmount(part.price);
                    });
                }
                /* eslint-disable no-alert, no-console */
                console.log(this.booking.total);
            },
            closeDialog() {
                this.tab = 0;
                this.editInOldSystem = false;
                EventBus.$emit('reset-booking');
                this.$store.dispatch('bookings/resetActiveBooking');
                this.$store.dispatch('bookings/setManageBookingDialog', false);
            },
            validateBooking() {
                if (this.booking.days !== this.booking.dailyTotals.length) {
                    EventBus.$emit('message', {message: 'Daily Totals do not match number of days', type: 'error'});
                    return false;
                } else if (this.booking.customer && this.booking.customer.name && this.booking.startDate && this.booking.total) {
                    return true;
                }
            },
            async saveBooking() {
                if (this.validateBooking()) {
                    this.isLoading = true;
                    try {
                        await BookingsHttp.updateExistingBooking(this.booking._id, this.booking);
                        EventBus.$emit('message', {message: 'Booking Saved Successfully', type: 'success'});
                        await this.$store.dispatch('bookings/resetActiveBooking');
                        await this.$store.dispatch('bookings/setBookings', {day: this.$moment().startOf('isoWeek').toDate(), isWeek: true});
                        this.closeDialog();
                    } catch (e) {
                        EventBus.$emit('message', {message: e, type: 'error'});
                    } finally {
                        this.isLoading = false;
                    }
                }
            },
            async createBooking() {
                if (this.validateBooking()) {
                    this.isLoading = true;
                    try {
                        await BookingsHttp.createNewBooking(this.booking);
                        EventBus.$emit('message', {message: 'Booking Created Successfully', type: 'success'});
                        if (this.booking.estimateDate) {
                            // Is also an estimate so we need to mark the things
                            const estimate = this.$store.state.estimates.activeEstimate;
                            estimate.isBooking = true;
                            await EstimatesHttp.updateExistingEstimate(estimate._id, estimate, true);
                        }
                        await this.$store.dispatch('estimates/resetActiveEstimate');
                        await this.$store.dispatch('estimates/setEstimates');
                        await this.$store.dispatch('bookings/resetActiveBooking');
                        await this.$store.dispatch('bookings/setBookings', {day: this.$moment().startOf('isoWeek').toDate(), isWeek: true});
                        this.closeDialog();
                    } catch (e) {
                        EventBus.$emit('message', {message: e, type: 'error'});
                    } finally {
                        this.isLoading = false;
                    }
                }
            },
            async processBooking() {
                this.booking._id ? this.saveBooking() : this.createBooking();
            }
        }
    }
</script>

<style scoped>

</style>
